import { render, staticRenderFns } from "./HistoryDialogForm.vue?vue&type=template&id=5b783d2e&"
import script from "./HistoryDialogForm.vue?vue&type=script&lang=js&"
export * from "./HistoryDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports